import { CHECKOUT_ERROR_CODES } from '@iheartjane/types';
import type {
  CheckoutErrorCode,
  CheckoutErrorDetails,
} from '@iheartjane/types';
import type { ReactNode } from 'react';

interface CheckoutErrorCopy {
  body: ReactNode;
  detail: string;
}

const COPY: Record<
  CheckoutErrorCode,
  (title?: string | null) => CheckoutErrorCopy
> = {
  [CHECKOUT_ERROR_CODES.brandSpecialBudgetExhausted]: (title) => ({
    body: title ? (
      <>
        The <strong>{title}</strong> reward isn't available for this order and
        has been removed.
      </>
    ) : (
      "Your Jane Gold cash back reward isn't available for this order and has been removed."
    ),
    detail:
      "This order won't earn Jane Gold cash back. Your order total hasn't changed and you haven't been charged.",
  }),
};

export const checkoutErrorCopy = (
  details?: CheckoutErrorDetails | null
): CheckoutErrorCopy | null =>
  details ? (COPY[details.code]?.(details.title) ?? null) : null;
